import { ExploreSortKey } from './types';

/**
 * Default sort config for the Explore & Compare table.
 * This is used as a fallback when the API config is not available.
 * Each earlier key in the array has higher priority; if a tie occurs, compare using the next key, and so on.
 */
export const DEFAULT_EXPLORE_SORT_CONFIG: ExploreSortKey[] = [
	{
		key: 'specific_asset',
		symbol: 'USDC',
	},
	{
		key: 'specific_asset',
		symbol: 'SOL',
	},
	{
		key: 'apy',
		direction: 'desc',
		filter: {
			conditions: [
				{
					field: 'total_deposit',
					operator: 'gte',
					value: 1000000, // $1M+ deposits
				},
			],
			logic: 'and',
		},
	},
	{
		key: 'total_deposit',
		direction: 'desc',
	},
];
